<template>
    <v-container fluid class="pa-4">
        <v-card>
            <v-toolbar flat>
                <v-text-field v-model="query" append-icon="search" label="Cerca per titolo, contesto, autore o linguaggio"
                    single-line hide-details outlined dense clearable autofocus @input="onQueryChange"
                    class="mr-2" />

                <v-spacer />

                <v-btn color="primary" elevation="2" @click="nuovoElemento">
                    <v-icon left>add</v-icon>
                    Nuovo Elemento
                </v-btn>
            </v-toolbar>

            <v-divider />

            <v-data-table :headers="headers" :items="risultati" :loading="loading" disable-pagination
                hide-default-footer class="elevation-0 riga-cliccabile" @click:row="apriDettaglio"
                :sort-by="['dataPubblicazione']" :sort-desc="[true]">

                <template v-slot:item.titolo="{ item }">
                    <div class="font-weight-medium">{{ item.titolo }}</div>
                </template>

                <template v-slot:item.maturita="{ item }">
                    <v-chip small :color="maturitaColor(item.maturita)" text-color="white">
                        {{ maturitaLabel(item.maturita) }}
                    </v-chip>
                </template>

                <template v-slot:item.dataPubblicazione="{ item }">
                    {{ formatData(item.dataPubblicazione) }}
                </template>

                <template v-slot:no-data>
                    <div class="text-center py-8">
                        <v-icon size="64" color="grey lighten-1">inventory_2</v-icon>
                        <div class="text-h6 mt-4 grey--text">
                            {{ query ? 'Nessun risultato per la ricerca' : 'Nessuna voce nel catalogo' }}
                        </div>
                        <v-btn color="primary" class="mt-4" @click="nuovoElemento">
                            <v-icon left>add</v-icon>
                            Aggiungi la prima voce
                        </v-btn>
                    </div>
                </template>
            </v-data-table>
        </v-card>

        <catalogo-detail-drawer v-model="dialogDettaglio" :item="itemSelezionato" @modifica="modificaElemento" />

        <catalogo-form-dialog v-model="dialogForm" :item="itemCorrente" :tags="tags" @saved="onSalvato"
            @close="dialogForm = false" />

        <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="3000">
            {{ snackbar.text }}
            <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" @click="snackbar.show = false">
                    Chiudi
                </v-btn>
            </template>
        </v-snackbar>
    </v-container>
</template>

<script>
import { searchCatalogo, getTagsCatalogo } from '@/api/api.catalogo.js';
import CatalogoDetailDrawer from './CatalogoDetailDrawer.vue';
import CatalogoFormDialog from './CatalogoFormDialog.vue';

export default {
    name: 'Catalogo',

    components: {
        CatalogoDetailDrawer,
        CatalogoFormDialog,
    },

    data() {
        return {
            loading: false,
            query: '',
            ricercaTimeout: null,
            risultati: [],
            tags: [],

            dialogDettaglio: false,
            itemSelezionato: null,

            dialogForm: false,
            itemCorrente: null,

            snackbar: {
                show: false,
                text: '',
                color: 'success'
            },

            headers: [
                { text: 'Titolo', value: 'titolo', sortable: true },
                { text: 'Linguaggio', value: 'stack', sortable: true },
                { text: 'Autore', value: 'autore', sortable: true },
                { text: 'Maturità', value: 'maturita', sortable: true },
                { text: 'Data', value: 'dataPubblicazione', sortable: true },
            ],
        };
    },

    async mounted() {
        await this.caricaTags();
        await this.cerca();
    },

    methods: {
        async caricaTags() {
            try {
                const response = await getTagsCatalogo();
                this.tags = response.data.data;
            } catch (error) {
                console.error('Errore caricamento tag:', error);
            }
        },

        async cerca() {
            this.loading = true;
            try {
                const response = await searchCatalogo(this.query);
                this.risultati = response.data.data;
            } catch (error) {
                this.$toast.alert('Errore nella ricerca nel catalogo');
                console.error(error);
            } finally {
                this.loading = false;
            }
        },

        onQueryChange() {
            clearTimeout(this.ricercaTimeout);
            this.ricercaTimeout = setTimeout(() => {
                this.cerca();
            }, 150);
        },

        nuovoElemento() {
            this.itemCorrente = null;
            this.dialogForm = true;
        },

        modificaElemento(item) {
            this.dialogDettaglio = false;
            this.itemCorrente = { ...item };
            this.dialogForm = true;
        },

        apriDettaglio(item) {
            this.itemSelezionato = item;
            this.dialogDettaglio = true;
        },

        onSalvato() {
            this.dialogForm = false;
            this.itemCorrente = null;
            this.cerca();
        },

        formatData(data) {
            if (!data) return '-';
            return this.$i2kFunctions.formatISODate(data);
        },

        maturitaLabel(maturita) {
            const labels = {
                grezzo: 'Grezzo',
                rodato: 'Rodato',
                non_riusare: 'Non riusare'
            };
            return labels[maturita] || maturita;
        },

        maturitaColor(maturita) {
            const colors = {
                grezzo: 'orange',
                rodato: 'success',
                non_riusare: 'error'
            };
            return colors[maturita] || 'grey';
        },
    }
};
</script>

<style scoped>
.riga-cliccabile >>> tbody tr {
    cursor: pointer;
}
</style>
